<ion-content fullscreen="true">
  <ion-grid>
    <ion-row>
      @if (!platform.is("ios")) {
        <ion-col size="7" class="ion-hide-sm-down">
          <sol-ads />
        </ion-col>
      }
      <ion-col
        size="12"
        [sizeSm]="!platform.is('ios') ? 5 : 12"
        class="center grey-bg"
      >
        <div class="login-holder">
          <img
            class="logo"
            src="../../assets/images/logo-sollo.svg"
            alt="Sollo"
            draggable="false"
          />
          <form [formGroup]="loginForm" (ngSubmit)="onUserLogin()">
            <ion-list>
              <ion-item>
                <ion-input
                  label="Email"
                  labelPlacement="floating"
                  placeholder="Email"
                  type="email"
                  autocomplete="off"
                  formControlName="email"
                >
                </ion-input>
              </ion-item>
              <ion-item>
                <ion-input
                  label="Password"
                  labelPlacement="floating"
                  placeholder="Password"
                  [type]="passwordVisible ? 'text' : 'password'"
                  autocomplete="off"
                  formControlName="password"
                >
                </ion-input>
                <ion-icon
                  slot="end"
                  class="input-icon"
                  [name]="passwordVisible ? 'eye-off-outline' : 'eye-outline'"
                  (click)="togglePasswordVisibility()"
                >
                </ion-icon>
              </ion-item>
            </ion-list>
            <ion-button fill="outline" color="secondary" type="submit"
              >Login</ion-button
            >
            <span class="forgot-password" (click)="showForgotPassword()"
              >Forgot Password</span
            >
          </form>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
